import { structuredTheme } from 'ia-react-core';
import { AppTheme } from '../interfaces/Theme';
import { ReactComponent as LogoFr } from './assets/images/InvestiaF.svg';
import { ReactComponent as LogoEn } from './assets/images/InvestiaE.svg';

const appTheme: AppTheme = {
  ...structuredTheme,
  assets: {
    ...structuredTheme.assets,
    logoFr: LogoFr,
    logoEn: LogoEn,
  },
  layout: {
    ...structuredTheme.layout,
    maxContentWidth: 100000,
  },

  MainLogo: {
    ...structuredTheme.MainLogo,
    width: '218px',
    height: '40px',
    lgWidth: '218px',
    lgHeight: '40px',
  },

  Modal: {
    ...structuredTheme.Modal,
    background: '#fff',
    closeButtonBackground: 'transparent',
    closeButtonHoverBackground: 'transparent',
    closeButtonActiveBackground: 'transparent',
  },
};

export default appTheme;
